<template>
    <page :busy="busy" :tabs="tabs">
        <grid
            ref="grid"
            :rowData="rowData"
            :isSearch="false"
            :columnDefs="columnDefs"
            :treeData="true"
            :getDataPath="getDataPath"
            :autoGroupColumnDef="autoGroupColumnDef"
            :pinnedBottomRowData="pinnedBottomRowData"
            :getRowStyle="getRowStyle"
            :is-auto-width="true"
        ></grid>
    </page>
</template>

<script>
    import API from '../../../api';
    import { formatResponseError } from '../../../utils/api';
    import page from '../../generic/page/page.vue';
    import grid from '../../generic/grid/grid.vue';
    import modal from '../../generic/modal/modal.vue';
    import DescriptionCellRenderer from './description-cell-renderer.vue';
    import AmountCellRenderer from './amount-cell-renderer.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import { SUBSCRIPTION_ACTIVITY_GRID_ENDPOINT } from '../../../endpoints';

    export default {
        components: {
            page,
            modal,
            grid,
            descriptionCellRenderer: DescriptionCellRenderer,
            amountCellRenderer: AmountCellRenderer,
            actionsCellRenderer: ActionsCellRenderer,
        },
        beforeMount() {
            this.getRowStyle = params => {
                if (params.node.rowPinned) {
                    return { 'font-weight': 'bold' };
                }
            };
        },
        mounted() {
            this.fetchData();
            const grid = this.$refs.grid;
        },
        computed: {
            columnDefs() {
                return [
                    {
                        headerName: 'Description',
                        field: 'description',
                        cellRenderer: 'descriptionCellRenderer',
                        autoHeight: true,
                        sortable: false,
                        autoWidthExclude: true,
                        minWidth: 400,
                    },
                    {
                        headerName: 'Amount',
                        field: 'amount',
     
                        cellClass: 'ag-right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                        cellRenderer: 'amountCellRenderer',
                        sortable: false,
                        resizable: false
                    },
                    {
                        headerName: '',
      
                        cellRenderer: 'actionsCellRenderer',
                        cellClass: 'ag-center-aligned-cell',
                        sortable: false,
                        resizable: false,
                    },
                ];
            },
            pinnedBottomRowData() {
                return [
                    {
                        amount: this.totalAmount,
                    },
                ];
            },
        },
        data() {
            return {
                busy: false,
                tabs: [
                    {
                        active: false,
                        title: 'Billing',
                        route: '/app/subscription/billing/',
                    },
                    {
                        active: true,
                        title: 'Activity',
                        route: '/app/subscription/activity/',
                    },
                ],
                rowData: [],
                autoGroupColumnDef: {
                    flex: 1,
                    minWidth: 150,
                    maxWidth: 150,
                    resizable: true,
                    sortable: false,
                    headerName: 'Date',
                    cellRendererParams: {
                        innerRenderer: ({ data }) => data.payment_date,
                    },
                },
                getDataPath: data => data.id_hierarchy,
                totalAmount: 0,
            };
        },
        methods: {
            async fetchData() {
                try {
                    this.busy = true;
                    const { data } = await API.get(SUBSCRIPTION_ACTIVITY_GRID_ENDPOINT());
                    this.rowData = data.payments.concat(data.split_payments);
                    this.totalAmount = data.total_paid;
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch activity.' });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped></style>
